import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ hasFilters, onClearFilters }) => {
  const navigate = useNavigate();

  if (hasFilters) {
    return (
      <div className="card text-center py-12">
        <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="Search" size={32} color="var(--color-muted-foreground)" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">
          No Registrations Found
        </h3>
        <p className="text-muted-foreground mb-6 max-w-md mx-auto">
          No registrations match your current filters. Try adjusting your search criteria.
        </p>
        <Button
          variant="outline"
          iconName="X"
          iconPosition="left"
          onClick={onClearFilters}
        >
          Clear Filters
        </Button>
      </div>
    );
  }

  return (
    <div className="card text-center py-12">
      <div className="w-20 h-20 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name="Trophy" size={40} color="var(--color-primary)" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-2">
        No Registrations Yet
      </h3>
      <p className="text-muted-foreground mb-6 max-w-md mx-auto">
        You haven't created any team registrations yet. Start by creating your first registration for the MI Junior Cricket Tournament.
      </p>
      <Button
        variant="default"
        size="lg"
        iconName="Plus"
        iconPosition="left"
        onClick={() => navigate('/team-registration-form')}
      >
        Create First Registration
      </Button>
    </div>
  );
};

export default EmptyState;